@if (isAllowedPath() ) { <app-navbar />}
<div class="flex w-full">
  @if (isAllowedPath() ) {
  <app-sidebar [currentPath]="currentPath" />
  }
  <div
    class="w-full {{
      sidebarService.isOpen() && isAllowedPath() ? 'sm:pl-[250px]' : ''
    }}"
  >
    <router-outlet />
  </div>
</div>

<ngx-ui-loader [pbColor]="'#005FFF'" [fgsTemplate]="spinnerTemplate">
</ngx-ui-loader>
<ng-template #spinnerTemplate>
  <app-loader-template />
</ng-template>
